<template>
  <DefaultModal class="subletinfo-modal-wrapper" @close="$emit('close')">
    <template #header>
      <DefaultModalTitle><slot name="title" /></DefaultModalTitle>
    </template>

    <template #body>
      <div class="body-wrapper">
        <section class="body-section">
          <h2 class="title">
            <template v-if="landlordHasAccess">Rättigheter saknas</template
            ><slot v-else name="intro" />
          </h2>

          <section class="modal-bullets-container">
            <p class="contact-info">
              <template v-if="!landlordHasAccess">
                <slot name="body">
                  Tyvärr verkar ni (<strong>{{ account.landlordName }}</strong
                  >) inte ha tillgång till denna modul.
                </slot>
                <br /><br />Kontakta <strong>Morgan</strong> för mer
                information:
                <br />
                <ul>
                  <li>
                    <a
                      href="mailto:morgan@lagenhetsbyte.se?subject=Bytesansökan"
                      >morgan@lagenhetsbyte.se</a
                    >
                  </li>
                  <li>070-815 61 74</li>
                </ul>
              </template>
              <template v-else>
                Tyvärr verkar du inte ha tillgång till denna modul.
              </template>
            </p>
          </section>
        </section>
      </div>
    </template>

    <template #footer>
      <BaseButton :is-rounded="true" :is-default="true" @click="$emit('close')"
        >Stäng</BaseButton
      >
    </template>
  </DefaultModal>
</template>

<script>
import { mapState } from 'vuex';
import DefaultModal from '@/components/DefaultModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import outsideClick from '@/directives/outside-click';
import DefaultModalTitle from '@/components/DefaultModalTitle.vue';

export default {
  name: 'AccessInfoModal',
  directives: { outsideClick },
  components: {
    DefaultModal,
    DefaultModalTitle,
    BaseButton
  },
  props: {
    landlordHasAccess: {
      type: Number,
      required: true
    }
  },
  emits: ['close'],

  computed: {
    ...mapState({
      account: state => state.app.account
    })
  }
};
</script>

<style scoped>
.subletinfo-modal-wrapper :deep(.footer) {
  padding: 15px 35px;
}
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 100%;
  width: 450px;
}
.body-wrapper .body-section .title {
  width: 100%;
  font-size: 1.8rem;
  padding: 0 0 0.8rem 0;
  font-weight: 400;
}
.body-wrapper .body-section .modal-bullets-container {
  width: 100%;
  font-size: 1.4rem;
}
.body-wrapper .body-section .modal-bullets-container .contact {
  font-size: 1.6rem;
}
.body-wrapper .body-section .modal-bullets-container a {
  text-decoration: none;
  color: var(--color-blue);
}
.body-wrapper .body-section .modal-bullets-container a:hover {
  text-decoration: underline;
}

.contact-info {
  font-size: 1.6rem;
}
.contact-info a {
  text-decoration: none;
  color: var(--color-blue);
}
.contact-info a:hover {
  text-decoration: underline;
}
</style>
